import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { DataService } from './data.service';


@Injectable({
  providedIn: 'root'
})
export class APIService {

  private apiUrl = environment.apiUrlBase;
  private apiUrlExternal = environment.apiUrlExternal;

  constructor(
    private http: HttpClient,
    private dataServices: DataService
  ) {}

  get(endpoint: string): Observable<any> {
    return this.http.get(this.apiUrl + endpoint).pipe(
      catchError(this.handleError)
    );
  }

  post(endpoint: string, data: any): Observable<any> {
    return this.http.post(this.apiUrl + endpoint, data).pipe(
      catchError(this.handleError)
    );
  }

  postExternal(endpoint: string, data: any): Observable<any> {
    return this.http.post(this.apiUrlExternal + endpoint, data).pipe(
      catchError(this.handleError)
    );
  }

  put(endpoint: string, data: any): Observable<any> {
    return this.http.put(this.apiUrl + endpoint, data).pipe(
      catchError(this.handleError)
    );
  }

  delete(endpoint: string): Observable<any> {
    return this.http.delete(this.apiUrl + endpoint).pipe(
      catchError(this.handleError)
    );
  }



  // Manejo de errores centralizado
 private handleError(error: HttpErrorResponse) {
  console.error('ERROR BACKEND RAW:', error);
  return throwError(() => error); // 👈 DEVUELVE EL ERROR COMPLETO
}


}
